import React from "react";
import { Link } from "react-router-dom";

const MAIN_SITE = "https://francescaspinazzola.it";

const NAV_PILLS = [
  { label: "Home", type: "anchor", target: "top" },
  { label: "Chi Sono", type: "external", href: `${MAIN_SITE}/#chi-sono` },
  { label: "Servizi", type: "external", href: `${MAIN_SITE}/servizi-extra` },
  { label: "I Miei Lavori", type: "external", href: `${MAIN_SITE}/portfolio` },
  { label: "Blog", type: "external", href: `${MAIN_SITE}/blog` },
  { label: "Contatti", type: "external", href: `${MAIN_SITE}/#contatti` },
];

const Header = () => {
  const scrollTo = (id) => {
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const renderPill = (item, index) => {
    const style = { animationDelay: `${0.15 + index * 0.07}s` };
    if (item.type === "anchor") {
      return (
        <button
          key={item.label}
          className="pill"
          style={style}
          onClick={() => scrollTo(item.target)}
        >
          <span>{item.label}</span>
        </button>
      );
    }
    return (
      <a
        key={item.label}
        className="pill"
        style={style}
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>{item.label}</span>
      </a>
    );
  };

  return (
    <header className="top-nav">
      <nav className="top-nav-inner">
        {NAV_PILLS.map((item, i) => renderPill(item, i))}
        <Link
          className="pill pill-cta"
          style={{ animationDelay: `${0.15 + NAV_PILLS.length * 0.07}s` }}
          to="/consulenze"
          data-testid="header-prenota-btn"
        >
          <span>Prenota una chiacchierata</span>
        </Link>
      </nav>
    </header>
  );
};

export default Header;
